import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { BtnActions, IconTypeEnum, TableColumnType,TableColumn } from '../../../common/interfaces/global-interfaces';
import { NotificationService } from '../../../services/notification.service';
import { SettingsService } from '../../../services/settings.service';
import { LayoutService } from '../../../shared/components/app-layout/shared-layout/layout.service';
import { AppState } from '../../../store';
import { StoreItemActions } from '../../../store/entities/store-item/store-item.actions';
import { StoreItemEntity } from '../../../store/entities/store-item/store-item.model';
import { BillingAddComponent } from '../../billing-management/billing-add/billing-add.component';
import { GET_ALL_BILLINGS, CANCEL_BILLING_MUTATION } from '../../billing-management/billing.graphql';
import { Bill } from '../../subscription-management/subscription.model';

@Component({
  selector: 'app-corporate-billing',
  templateUrl: './corporate-billing.component.html',
  styleUrl: './corporate-billing.component.scss'
})
export class CorporateBillingComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly settings = inject(SettingsService);
  private readonly notify = inject(NotificationService);
  private readonly store = inject(Store<AppState>);
  readonly layoutService = inject(LayoutService);

  title = 'Billing List';

 
  addPermission: string[] = ['NO_PERMISSION'];

 
  query = GET_ALL_BILLINGS;
  upsertAction = StoreItemActions.upsertStoreItem;
  deleteAction = StoreItemActions.deleteStoreItem;
  storeEntity: StoreItemEntity = StoreItemEntity.bill; 

  additionalVariables = {
    pageNumber:0,
    itemsPerPage:10,
  };

  viewDetails = false;
  viewDetailsTitle = 'View Bill';

  tableColumns: TableColumn[] = [];
  tableActions: BtnActions[] = [
    {
      id: 'more',
      title: 'Actions',
      permissions: ['NO_PERMISSION'],
      icon: 'more_horiz',
      iconType: IconTypeEnum.MATERIAL,
      children: [
        {
          id: 'view',
          title: 'View',
          permissions: ['NO_PERMISSION'],
          icon: 'visibility',
          iconType: IconTypeEnum.MATERIAL,
        },
        // {
        //   id: 'edit',
        //   title: 'Edit',
        //   permissions: ['NO_PERMISSION'],
        //   icon: 'create',
        //   iconType: IconTypeEnum.MATERIAL,
        // },
        // {
        //   id: 'delete',
        //   title: 'Delete',
        //   permissions: ['NO_PERMISSION'],
        //   icon: 'delete',
        //   iconType: IconTypeEnum.MATERIAL,
        // },
      ],
    },
  ];

  ngOnInit(): void {
this.tableColumns = [
  { keyword: '', title: 'SN', type: TableColumnType.index },
  { keyword: 'billId', title: 'Bill ID', sortableColumn: 'billId' },
  { keyword: 'controlNumber', title: 'Control Number', sortableColumn: 'controlNumber' },
{ keyword: 'customerName', title: 'Customer' },
  // { keyword: 'subscription.userAccount.phone', title: 'Phone', sortableColumn: 'subscription.userAccount.phone' },
  // { keyword: 'paymentType', title: 'Payment Type', sortableColumn: 'paymentType' },
  { keyword: 'billStatus', title: 'Status', sortableColumn: 'billStatus' },
  // { keyword: 'currencyType', title: 'Currency', sortableColumn: 'currencyType' },
  { keyword: 'totalAmount', title: 'Amount', sortableColumn: 'totalAmount' },
  { keyword: 'billDate', title: 'Bill Date', sortableColumn: 'billDate',type: TableColumnType.date },
    { keyword: 'controlNumberExpiredDate', title: 'Expiry Date', sortableColumn: 'controlNumberExpiredDate', type: TableColumnType.date }, 

  { keyword: 'actions', title: 'Actions', isActionColumn: true },
];


  }

  trackByUuid = (_: number, item: Bill) => item.uuid;

 onView(bill: Bill): void {
  this.router.navigate(['/corporate/billing', bill.uuid]);
}


  onAdd(bill?: Bill): void {
    this.settings.openDialogModal({
      component: BillingAddComponent,
      data: { bill },
      width: '800px',
    });
  }

  btnClicked(ev: { id: string; data: Bill }): void {
    if (!ev?.data) return;
    const bill = ev.data;

    switch (ev.id) {
      case 'view':
        this.onView(bill);
        break;
    
      default:
        console.warn(`Unhandled action: ${ev.id}`);
    }
  }

  onDelete(bill: Bill): void {
    this.notify
      .confirmation({
        title: 'Delete Bill',
        message: `Are you sure you want to delete bill #${bill.billId || bill.uuid}?`,
      })
      .then((confirmed) => {
        if (confirmed) {
          this.store.dispatch(
            StoreItemActions.removeStoreItem({
              entity: this.storeEntity,
              mutation: CANCEL_BILLING_MUTATION,
              input: { uuid: bill.uuid },
              id: bill.uuid,
            })
          );
        }
      });
  }
mapBillingData = (item: any) => {
  return {
    ...item,
    // customerName: item?.subscription?.userAccount?.fullName ?? '-',
      customerName: item?.payer?.fullName || '-', 
    customerPhone: item?.subscription?.userAccount?.phone ?? '-',
  };
};




  closePanel(): void {
    this.viewDetails = false;
    this.layoutService.closePanel();
  }
}
